
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redaktionsstatut",
      function () {
        return require("private-next-pages/redaktionsstatut/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redaktionsstatut"])
      });
    }
  